import Leasing from './views/main.js';
export default Leasing;
